import React, { useContext } from 'react'
import RequestsAll from '../context/RequestsContext'

const useAllRequests = () => {
  const doc = useContext(RequestsAll)
  return doc;
};

export default useAllRequests;
